import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import localizationResources from './i18nResources.js';
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    debug: import.meta.env.MODE === 'development',
    supportedLngs: localizationResources.supportedLanguages,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
    resources: localizationResources.resources,
});
const updateDocumentLang = (lng) => document.documentElement.setAttribute('lang', lng);
updateDocumentLang(i18n.language);
i18n.on('languageChanged', updateDocumentLang);
export default i18n;
